import Vue from 'vue'
import App from './App.vue'
import router from './config/router'
import siteMeta from './data/siteMeta.js'
import projectsMeta from './data/projectsMeta.js'
import './assets/styles/index.sass'
import 'lazysizes'

Vue.config.productionTip = false

new Vue({
  router, 
  render: h => h(App, {
    props:{
      siteMeta: siteMeta, 
      projectsMeta: projectsMeta
    }
  }),
}).$mount('#app')
